import { createContext, useContext } from "react";

// `{ themePalette, changeThemePalette }`, provided by App.js.
export const ThemePaletteContext = createContext();

export const useThemePalette = () => useContext(ThemePaletteContext);
